// extracted by mini-css-extract-plugin
export default {"modal":"style_modal__Pm3cF","modal__container":"style_modal__container__fYcZh","modal__btn_icon":"style_modal__btn_icon__7OpYL","button":"style_button__9exMy"};